import React from "react";
import ReactApexChart from "react-apexcharts";
import {ShowChart as ChartIcon} from "@mui/icons-material";
import ChartCard from "../ChartCard";
import {apexChartsCommonConfig, commonChartColors} from "../Chartconfig";

const VolumeHistoryChart = ({volumeHistory, volumeGrowthSinceStart}) => {
    if (!volumeHistory || volumeHistory.length === 0) return null;

    const categories = volumeHistory.map((p) => p.weekLabel || `שבוע ${p.weekIndex + 1}`);
    const data = volumeHistory.map((p) => Math.round(p.volume || 0));

    const options = {
        ...apexChartsCommonConfig,
        chart: {
            ...apexChartsCommonConfig.chart,
            type: "area",
            height: 280,
        },
        xaxis: {
            ...apexChartsCommonConfig.xaxis,
            categories,
        },
        yaxis: {
            ...apexChartsCommonConfig.yaxis,
            labels: {
                ...apexChartsCommonConfig.yaxis.labels,
                formatter: (val) => {
                    if (val >= 1000) return `${(val / 1000).toFixed(1)}K`;
                    return Math.round(val);
                },
            },
        },
        colors: [commonChartColors.primary],
        tooltip: {
            ...apexChartsCommonConfig.tooltip,
            y: {
                formatter: (val) => `${val.toLocaleString()} ק״ג`,
            },
        },
    };

    const series = [{name: "נפח אימון", data}];

    const growthBadge =
        volumeGrowthSinceStart != null
            ? `${volumeGrowthSinceStart > 0 ? "+" : ""}${Math.round(volumeGrowthSinceStart)}% מתחילת התוכנית`
            : null;

    return (
        <ChartCard
            title="מגמת נפח אימון"
            icon={ChartIcon}
            flexBasis="100%"
            headerAction={
                growthBadge && (
                    <span
                        style={{
                            fontSize: "12px",
                            fontWeight: 600,
                            color: volumeGrowthSinceStart >= 0 ? "#10B981" : "#EF4444",
                            backgroundColor: volumeGrowthSinceStart >= 0 ? "#DCFCE7" : "#FEE2E2",
                            padding: "4px 10px",
                            borderRadius: "9999px",
                        }}
                    >
                        {growthBadge}
                    </span>
                )
            }
        >
            <ReactApexChart options={options} series={series} type="area" height={280}/>
        </ChartCard>
    );
};

export default VolumeHistoryChart;
